module.exports = __webpack_public_path__ + "img/why-choose-icon.a30a31ce.svg";